import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css"

import { Button } from "components/shared/panda/Button"
import { getHref, parseBackground, useSizing } from "lib/helpers"
import LiteYoutubeEmbed from "react-lite-youtube-embed"
import type { YoutubeEmbed } from "schemas"
import { css, cx } from "styled-system/css"
import { Container, styled, VStack } from "styled-system/jsx"

type Props = YoutubeEmbed

function Component({
  title,
  url,
  cta,

  sizingTop,
  sizingBottom,
  sizingTopMobile,
  sizingBottomMobile,
  backgroundColor1,
  backgroundColor2,
  backgroundStyle,
}: Props) {
  return (
    <styled.div
      data-block="youtubeEmbed"
      style={
        {
          background: parseBackground(
            backgroundColor1,
            backgroundColor2,
            backgroundStyle
          ),
          "--pt": useSizing(sizingTop) || "64px",
          "--pb": useSizing(sizingBottom) || "64px",
          "--ptm": useSizing(sizingTopMobile),
          "--pbm": useSizing(sizingBottomMobile),
        } as React.CSSProperties
      }
      css={{
        pt: "var(--ptm, var(--pt))",
        pb: "var(--pbm, var(--pb))",
        bgColor: "rgba(136, 156, 255, 0.29)",

        lg: {
          pt: "var(--pt)",
          pb: "var(--pb)",
        },
      }}>
      <Container>
        <VStack gap={4}>
          <styled.div
            css={{
              width: "100%",
            }}>
            <LiteYoutubeEmbed
              id={url}
              title="video"
              poster="maxresdefault"
              params=""
              playerClass={cx(
                "lty-playbtn",
                css({
                  borderRadius: "50%!",
                  backgroundColor: "#fffc!",
                  height: "80px!",
                  width: "80px!",

                  "&:before": {
                    transform: "translate(-30%, -50%) scale(1.5)!",
                    borderLeftColor: "primary.2!",
                  },
                })
              )}
            />
          </styled.div>
          {cta && (
            <Button
              variant="filled"
              fillColor="secondary"
              color="white"
              size="medium"
              href={getHref(cta)}>
              {cta.text}
            </Button>
          )}
        </VStack>
      </Container>
    </styled.div>
  )
}

export default Component
export type { Props as YoutubeEmbedProps }
